import { render, staticRenderFns } from "./courseIntroduction.vue?vue&type=template&id=50516d0a&scoped=true&"
import script from "./courseIntroduction.vue?vue&type=script&lang=js&"
export * from "./courseIntroduction.vue?vue&type=script&lang=js&"
import style0 from "./courseIntroduction.vue?vue&type=style&index=0&id=50516d0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50516d0a",
  null
  
)

export default component.exports